export default __webpack_public_path__ + "static/media/desktop.35fc7149.svg";